import { HELP_ARTICLES, HELP_VIDEOS } from "../help/helpContent";
import { nameMatches } from "./nameMatches";

/** How many help articles and videos instant search lists. */
const HELP_RESULTS = 5;

export type HelpResult =
  | { kind: "Article"; id: string; title: string; path: string }
  | { kind: "Video"; id: string; title: string };

const matches = (text: string, { title, tags }: { title: string; tags: string[] }) =>
  nameMatches(title, text) || tags.some((tag) => nameMatches(tag, text));

/** Help articles, then tutorial videos, whose title or tags match what's being typed, for instant search. */
export function searchHelp(text: string): HelpResult[] {
  return [
    ...HELP_ARTICLES.filter((a) => matches(text, a)).map(({ id, title, path }) => ({
      kind: "Article" as const,
      id,
      title,
      path,
    })),
    ...HELP_VIDEOS.filter((v) => matches(text, v)).map(({ id, title }) => ({
      kind: "Video" as const,
      id,
      title,
    })),
  ].slice(0, HELP_RESULTS);
}
